{
  "el": {
    "whats_new": {
      "category": {
        "news": "Νέα",
        "product": "Ενημέρωση προϊόντος",
        "tip": "Συμβουλή"
      },
      "category_plural": {
        "news": "Νέα",
        "product": "Ενημερώσεις προϊόντος",
        "tip": "Συμβουλές"
      },
      "earlier": "Παλαιότερα",
      "empty_description": "Οι νέες λειτουργίες, συμβουλές και νέα της Ziggu θα εμφανίζονται εδώ.",
      "empty_title": "Δεν υπάρχουν δημοσιεύσεις ακόμα",
      "helpful": "Χρήσιμο",
      "helpful_impersonation": "Αυτό δεν είναι δυνατό κατά την υπόδυση.",
      "helpful_mark": "Σήμανση ως χρήσιμο",
      "helpful_marked": "Το βρήκες χρήσιμο",
      "image_open": "Άνοιγμα εικόνας {index} από {count}",
      "load_failed_description": "Έλεγξε τη σύνδεσή σου και δοκίμασε ξανά.",
      "load_failed_title": "Δεν ήταν δυνατή η φόρτωση των δημοσιεύσεων",
      "new": "Νέο",
      "no_matches_description": "Καμία δημοσίευση δεν ταιριάζει με την αναζήτηση ή τα φίλτρα. Εκκαθάρισε τα φίλτρα για να δεις όλες.",
      "no_matches_title": "Κανένα αποτέλεσμα",
      "read_more": "Ανάγνωση περισσότερων",
      "retry": "Επανάληψη",
      "search": "Αναζήτηση δημοσιεύσεων…",
      "subtitle": "Νέες λειτουργίες, συμβουλές και νέα από την ομάδα της Ziggu.",
      "title": "Τι νέο υπάρχει"
    }
  }
}
